import dayjs from "dayjs";

/**
 * formatISO
 * Safely formats a date string to YYYY-MM-DD for use in calendar events.
 */
export function formatISO(date) {
    const d = dayjs(date);
    return d.isValid() ? d.format("YYYY-MM-DD") : "";
}
